export default __webpack_public_path__ + "static/media/Group8873.d43e94ec.svg";